import { createGlobalStyle } from 'styled-components'
import { device } from './Media'
import { spacing } from './Rythms'

const Typography = createGlobalStyle`

  @font-face {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: local(''), url('/fonts/raleway-v28-latin-regular.woff2') format('woff2');
  }
  @font-face {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src:local(''),
    url('/fonts/raleway-v28-latin-600.woff2') format('woff2');
  }
  @font-face {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: local(''),
    url('/fonts/raleway-v28-latin-700.woff2') format('woff2');
  }
  @font-face {
    font-family: 'Raleway';
    font-style: italic;
    font-weight: 400;
    font-display: swap;
    src: local(''),
    url('/fonts/raleway-v28-latin-italic.woff2') format('woff2'); /* Chrome 26+, Opera 23+, Firefox 39+ */
  }
  @font-face {
    font-family: 'Fraunces';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: local(''),
    url('/fonts/fraunces-v24-latin-600.woff2') format('woff2'); /* Chrome 26+, Opera 23+, Firefox 39+ */
  }
  @font-face {
    font-family: 'Fraunces';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: local(''),
    url('/fonts/fraunces-v24-latin-700.woff2') format('woff2'); /* Chrome 26+, Opera 23+, Firefox 39+ */
  }
  @font-face {
    font-family: 'Fraunces';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: local(''),
    url('/fonts/fraunces-v24-latin-900.woff2') format('woff2'); /* Chrome 26+, Opera 23+, Firefox 39+ */
  }

  html {
    font-family: Raleway, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    color: var(--text);
    font-size: var(--font-base);
  }

  h1, h2, h3, h4, h5, h6, .serif {
    font-family: Fraunces, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    color: var(--text);
  }

  h1 {
    font-weight: 900;
    font-size: 32px;
    line-height: 120%;
    margin-bottom: ${spacing[8]};
  }
  h1.large {
    font-size: clamp(28px, 10vw, 48px);
  }

  h2 {
    font-weight: 700;
    font-size: 28px;
    line-height: 125%;
    margin-bottom: ${spacing[6]};
  }

  h3 {
    font-weight: 600;
    font-size: 24px;
    line-height: 135%;
    margin-bottom: ${spacing[6]};
  }

  h4 {
    font-weight: 700;
    font-size: 22px;
    line-height: 135%;
    margin-bottom: ${spacing[4]};
  }

  h5 {
    font-weight: 600;
    font-size: 20px;
    line-height: 130%;
    letter-spacing: 0.75px;
    margin-bottom: ${spacing[3]};
  }

  h6 {
    font-weight: 700;
    font-size: 18px;
    line-height: 140%;
    text-transform: uppercase;
  }

  a {
    color: var(--link);
    font-weight: 600;
    position: relative;
  }

  p {
    font-weight: 400;
    margin-bottom: ${spacing[6]};
    line-height: 150%;
    letter-spacing: .5px;
  }


  @media screen and ${device.tablet} {

    html {
      font-size: var(--font-md);
    }

    h1 {
      font-size: 48px;
    }
    h1.large {
      font-size: 64px;
    }

    h2 {
      font-size: 36px;
    }

    h3 {
      font-size: 30px;
      line-height: 130%;
    }

    h4 {
      font-size: 24px;
      line-height: 130%;
    }
  }
`

export default Typography
